export default "__VITE_ASSET__e089583f__"